import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ShipmentHook({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ShipmentHook</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 9.21973C3 8.66744 3.44772 8.21973 4 8.21973H20C20.5523 8.21973 21 8.66744 21 9.21973V18.0781C21 18.6303 20.5523 19.0781 20 19.0781H4C3.44772 19.0781 3 18.6303 3 18.0781V9.21973Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.14062 11.322V15.9756"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9995 11.322V15.9756"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8584 11.322V15.9756"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.57031 8.21989L9.23062 4.00194"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4279 8.21985L14.0762 4"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
